import React, { FC } from 'react'

import { styled } from '@linaria/react'
import { animated, useTransition } from '@react-spring/web'

import { StatusVariants } from 'components/block/StatusVariants/StatusVariants'
import { breakpoints } from 'components/designSystem/shared/breakpoints'

export const ProfileStatusAppearScroll: FC<{
  hasShowed?: boolean
  isOnline?: boolean
  hasVerified?: boolean
}> = ({ hasShowed, hasVerified, isOnline }) => {
  const transitions = useTransition(hasShowed, {
    from: { opacity: 0, top: -100 },
    enter: { opacity: 1, top: 12 },
    leave: { opacity: 0, top: -100 },
    config: { duration: 200 },
  })

  return transitions(
    (springs, show) =>
      show && (
        <Parent style={springs}>
          <StatusVariants
            variant="badge-status"
            size="mini"
            isOnline={isOnline}
            isVerified={hasVerified}
          />
        </Parent>
      )
  )
}

const Parent = styled(animated.div)`
  display: none;
  position: absolute;
  top: -100px;
  opacity: 0;
  z-index: 2;

  html[dir='ltr'] & {
    left: var(--spacing-16px);
  }

  html[dir='rtl'] & {
    right: var(--spacing-16px);
  }

  @media screen and (max-width: ${breakpoints.tablet - 1}px) {
    display: block;
  }
`
